// routes
import { PATH_DASHBOARD } from './routes/paths';

let apiKey = '/api';
let kcConfig = '/keycloak.json';
if (process.env.NODE_ENV === 'development') {
  apiKey = process.env.VITE_HOST_API_KEY || '';
  kcConfig = process.env.VITE_KEYCLOAK_CONFIG || '/keycloak.json';
}

export const HOST_API_KEY = apiKey;
export const KEYCLOAK_CONFIG = kcConfig;
export const DEV_MODE = Boolean(process.env.VITE_DEV_MODE);

export const MAP_API = process.env.VITE_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.app; // as '/dashboard/app'

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};

export const DEFAULT_COUNTRY = 'Germany';
